// DO NOT EDIT MANUALLY.
// price-source: @jersey/types/HOCKEY_BASE_PRICES
// Generated by scripts/sync_theme_pricing.mjs from the HUINA pricing source.
window.HUINA_HOCKEY_PRICING = 
{
  "pricingVersion": "HUINA_HOCKEY_USD_2026_06_25_V1",
  "workbookVersion": "HUINA_PRODUCT_PRICING_2026_06_25_V5_INDEPENDENT_SITE_CATEGORIES_CONFIRMED",
  "sourceSha256": "4e15076f53dd968410dd6d9fcd85d81147ce01dd95bb706722c40007d7f103c3",
  "source": "@jersey/types/HOCKEY_BASE_PRICES",
  "minQuantity": 10,
  "tiers": [
    "10-49",
    "50-149",
    "150-299",
    "300-499",
    "500+"
  ],
  "entries": {
    "printed__jersey__10-49": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "10-49",
      "priceCents": 5398,
      "variantId": 53145086132540
    },
    "printed__jersey__50-149": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "50-149",
      "priceCents": 5048,
      "variantId": 53165706543420
    },
    "printed__jersey__150-299": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "150-299",
      "priceCents": 4698,
      "variantId": 53165706576188
    },
    "printed__jersey__300-499": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "300-499",
      "priceCents": 4398,
      "variantId": 53165706608956
    },
    "printed__jersey__500+": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "500+",
      "priceCents": 4148,
      "variantId": 53165706641724
    },
    "printed__jersey-socks__10-49": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "10-49",
      "priceCents": 7697,
      "variantId": 53165706674492
    },
    "printed__jersey-socks__50-149": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "50-149",
      "priceCents": 7247,
      "variantId": 53165706707260
    },
    "printed__jersey-socks__150-299": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "150-299",
      "priceCents": 6697,
      "variantId": 53165706740028
    },
    "printed__jersey-socks__300-499": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "300-499",
      "priceCents": 6197,
      "variantId": 53165706772796
    },
    "printed__jersey-socks__500+": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "500+",
      "priceCents": 5747,
      "variantId": 53165706805564
    },
    "printed__jersey-socks-pant__10-49": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "10-49",
      "priceCents": 11696,
      "variantId": 53165706838332
    },
    "printed__jersey-socks-pant__50-149": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "50-149",
      "priceCents": 11046,
      "variantId": 53165706871100
    },
    "printed__jersey-socks-pant__150-299": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "150-299",
      "priceCents": 10196,
      "variantId": 53165706903868
    },
    "printed__jersey-socks-pant__300-499": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "300-499",
      "priceCents": 9396,
      "variantId": 53165706936636
    },
    "printed__jersey-socks-pant__500+": {
      "style": "printed",
      "styleLabel": "Printed",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "500+",
      "priceCents": 8746,
      "variantId": 53165706969404
    },
    "stitched__jersey__10-49": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "10-49",
      "priceCents": 8398,
      "variantId": 53165707002172
    },
    "stitched__jersey__50-149": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "50-149",
      "priceCents": 7898,
      "variantId": 53165707034940
    },
    "stitched__jersey__150-299": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "150-299",
      "priceCents": 7398,
      "variantId": 53165707067708
    },
    "stitched__jersey__300-499": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "300-499",
      "priceCents": 6898,
      "variantId": 53165707100476
    },
    "stitched__jersey__500+": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "500+",
      "priceCents": 6398,
      "variantId": 53165707133244
    },
    "stitched__jersey-socks__10-49": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "10-49",
      "priceCents": 10697,
      "variantId": 53165707166012
    },
    "stitched__jersey-socks__50-149": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "50-149",
      "priceCents": 10097,
      "variantId": 53165707198780
    },
    "stitched__jersey-socks__150-299": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "150-299",
      "priceCents": 9397,
      "variantId": 53165707231548
    },
    "stitched__jersey-socks__300-499": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "300-499",
      "priceCents": 8697,
      "variantId": 53165707264316
    },
    "stitched__jersey-socks__500+": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "500+",
      "priceCents": 7997,
      "variantId": 53165707297084
    },
    "stitched__jersey-socks-pant__10-49": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "10-49",
      "priceCents": 14696,
      "variantId": 53165707329852
    },
    "stitched__jersey-socks-pant__50-149": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "50-149",
      "priceCents": 13896,
      "variantId": 53165707362620
    },
    "stitched__jersey-socks-pant__150-299": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "150-299",
      "priceCents": 12896,
      "variantId": 53165707395388
    },
    "stitched__jersey-socks-pant__300-499": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "300-499",
      "priceCents": 11896,
      "variantId": 53165707428156
    },
    "stitched__jersey-socks-pant__500+": {
      "style": "stitched",
      "styleLabel": "Stitched",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "500+",
      "priceCents": 10996,
      "variantId": 53165707460924
    },
    "reversible__jersey__10-49": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "10-49",
      "priceCents": 7999,
      "variantId": 53165707493692
    },
    "reversible__jersey__50-149": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "50-149",
      "priceCents": 7499,
      "variantId": 53165707526460
    },
    "reversible__jersey__150-299": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "150-299",
      "priceCents": 6999,
      "variantId": 53165707559228
    },
    "reversible__jersey__300-499": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "300-499",
      "priceCents": 6499,
      "variantId": 53165707591996
    },
    "reversible__jersey__500+": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey",
      "packageLabel": "Jersey Only",
      "tier": "500+",
      "priceCents": 5999,
      "variantId": 53165707624764
    },
    "reversible__jersey-socks__10-49": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "10-49",
      "priceCents": 10298,
      "variantId": 53165707657532
    },
    "reversible__jersey-socks__50-149": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "50-149",
      "priceCents": 9698,
      "variantId": 53165707690300
    },
    "reversible__jersey-socks__150-299": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "150-299",
      "priceCents": 8998,
      "variantId": 53165707723068
    },
    "reversible__jersey-socks__300-499": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "300-499",
      "priceCents": 8298,
      "variantId": 53165707755836
    },
    "reversible__jersey-socks__500+": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey-socks",
      "packageLabel": "Jersey + Socks",
      "tier": "500+",
      "priceCents": 7598,
      "variantId": 53165707788604
    },
    "reversible__jersey-socks-pant__10-49": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "10-49",
      "priceCents": 14297,
      "variantId": 53165707821372
    },
    "reversible__jersey-socks-pant__50-149": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "50-149",
      "priceCents": 13497,
      "variantId": 53165707854140
    },
    "reversible__jersey-socks-pant__150-299": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "150-299",
      "priceCents": 12497,
      "variantId": 53165707886908
    },
    "reversible__jersey-socks-pant__300-499": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "300-499",
      "priceCents": 11497,
      "variantId": 53165707919676
    },
    "reversible__jersey-socks-pant__500+": {
      "style": "reversible",
      "styleLabel": "Reversible",
      "package": "jersey-socks-pant",
      "packageLabel": "Jersey + Socks + Pant Shell",
      "tier": "500+",
      "priceCents": 10597,
      "variantId": 53165707952444
    }
  }
}
;
